var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-header pb-4 px-5 pt-5" },
      [
        _c("h2", { staticClass: "text-center mb-4" }, [
          _vm._v(_vm._s(_vm.course.name))
        ]),
        _c("omegaup-markdown", {
          attrs: { "full-width": true, markdown: _vm.course.description }
        }),
        _vm.course.level
          ? _c("p", { staticClass: "text-center course-level" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.ui.formatString(_vm.T.courseIntroLevel, {
                      level: _vm.levels[_vm.course.level]
                    })
                  ) +
                  " "
              )
            ])
          : _vm._e(),
        _vm.displayCoursePrivacyBullets
          ? [
              _c("omegaup-markdown", {
                staticClass: "font-weight-bold h5",
                attrs: {
                  markdown: _vm.T.coursePrivacyConsent,
                  "full-width": true
                }
              }),
              _vm.needsBasicInformation
                ? _c("omegaup-markdown", {
                    attrs: {
                      markdown: _vm.T.courseBasicInformationNeeded,
                      "full-width": true
                    }
                  })
                : _vm._e(),
              _vm.course.requests_user_information != "no"
                ? [
                    _c("omegaup-markdown", {
                      attrs: {
                        markdown: _vm.statements.privacy.markdown || "",
                        "full-width": true
                      }
                    }),
                    _c("omegaup-radio-switch", {
                      staticClass: "align-to-markdown ml-5 mb-3",
                      attrs: {
                        value: _vm.shareUserInformation,
                        "selected-value": _vm.shareUserInformation
                      },
                      on: {
                        "update:value": function($event) {
                          _vm.shareUserInformation = $event
                        }
                      }
                    })
                  ]
                : _vm._e(),
              _vm.shouldShowAcceptTeacher
                ? [
                    _c("omegaup-markdown", {
                      attrs: {
                        markdown: _vm.statements.acceptTeacher.markdown || "",
                        "full-width": true
                      }
                    }),
                    _c("omegaup-radio-switch", {
                      staticClass: "align-to-markdown ml-5",
                      attrs: {
                        value: _vm.acceptTeacher,
                        "selected-value": _vm.acceptTeacher,
                        name: "accept-teacher"
                      },
                      on: {
                        "update:value": function($event) {
                          _vm.acceptTeacher = $event
                        }
                      }
                    })
                  ]
                : _vm._e()
            ]
          : _vm._e(),
        _c(
          "div",
          { staticClass: "text-center mt-3" },
          [
            _vm.loggedIn
              ? [
                  _vm.userRegistrationRequested === null ||
                  _vm.userRegistrationAccepted
                    ? _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSubmit($event)
                            }
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-lg",
                              attrs: {
                                name: "start-course-submit",
                                type: "submit",
                                disabled: _vm.isButtonDisabled
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.T.startCourse) + " ")]
                          )
                        ]
                      )
                    : !_vm.userRegistrationRequested
                    ? _c(
                        "form",
                        {
                          staticClass: "text-center",
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onRequestAccess($event)
                            }
                          }
                        },
                        [
                          _c("omegaup-markdown", {
                            attrs: {
                              markdown: _vm.T.mustRegisterToJoinCourse,
                              "full-width": true
                            }
                          }),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-lg",
                              attrs: { type: "submit" }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.T.registerForCourse) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : !_vm.userRegistrationAnswered
                    ? _c("omegaup-markdown", {
                        attrs: {
                          markdown: _vm.T.registrationPendingCourse,
                          "full-width": true
                        }
                      })
                    : _c("omegaup-markdown", {
                        attrs: {
                          markdown: _vm.T.registrationDenied,
                          "full-width": true
                        }
                      })
                ]
              : _c(
                  "a",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      role: "button",
                      href:
                        "/login/?redirect=" +
                        encodeURIComponent(_vm.window.location.pathname)
                    }
                  },
                  [_vm._v(_vm._s(_vm.T.loginLogIn))]
                )
          ],
          2
        )
      ],
      2
    ),
    _c("div", { staticClass: "mt-4" }, [
      _vm.course.objective
        ? _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c("h5", { staticClass: "intro-subtitle pb-1" }, [
                _vm._v(_vm._s(_vm.T.courseIntroWhatYouWillLearn))
              ]),
              _c("omegaup-markdown", {
                attrs: { markdown: _vm.course.objective, "full-width": true }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.course.school_id && _vm.course.school_name
        ? _c("div", [
            _c("h5", { staticClass: "intro-subtitle pb-1 mb-2" }, [
              _vm._v(_vm._s(_vm.T.courseIntroImpartedBy))
            ]),
            _vm._v(" " + _vm._s(_vm.course.school_name) + " ")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }